export default __webpack_public_path__ + "static/report_2.png";